<template>
  <v-app>
    <!-- Le portail terrain : une barre, et le travail. Pas de menu, pas d'organisation à choisir. -->
    <v-app-bar app color="primary" dark dense flat>
      <v-btn v-if="$route.name !== 'field'" icon :to="back" exact>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="text-subtitle-1">{{ $t('onboarding.field.title') }}</v-toolbar-title>
      <v-spacer />
      <span v-if="user" class="text-caption mr-2 d-none d-sm-inline">{{ user.firstname }} {{ user.lastname }}</span>
      <!-- Le back-office ne marche que sur ordinateur : le lien n'y est que là. Sur téléphone, on sort en se déconnectant. -->
      <v-btn v-if="!mobile" icon :to="{ name: 'dashboard' }" :title="$t('onboarding.field.back-office')">
        <v-icon>mdi-view-dashboard-outline</v-icon>
      </v-btn>
      <v-btn icon :title="$t('onboarding.field.logout')" @click="$auth.logout()">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="field-layout">
      <!-- Pas de v-container : la règle globale des pages lui retire toute marge. -->
      <div class="field-layout__content">
        <v-alert v-if="denied" type="warning" outlined>{{ $t('onboarding.field.denied') }}</v-alert>
        <router-view v-else-if="user" />
        <div v-else class="text-center py-10">
          <v-progress-circular indeterminate color="primary" />
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import SecurityRepository from '@repository/SecurityRepository'
import { isMobileDevice } from '@/utils/device'

/**
 * La mise en page du portail terrain : pensée pour un téléphone tenu d'une main, dans un parking.
 * Elle charge l'utilisateur elle-même — la mise en page du back-office, qui le fait d'ordinaire,
 * n'est pas là — et refuse l'accès à qui n'a pas le portail.
 */
export default {
  name: 'FieldLayout',

  data() {
    return { user: null, denied: false, mobile: isMobileDevice() }
  },

  computed: {
    /** Une fiche de borne ramène à la maintenance ; une pose, à la mise en service. */
    back() {
      return this.$route.name === 'field.charging-point' ? { name: 'field', query: { mode: 'maintenance' } } : { name: 'field' }
    },
  },

  async created() {
    try {
      const user = await SecurityRepository.me()
      this.$auth.setAuthenticated(true, user)
      this.$store.commit('currentUser', user)
      if (!(user.permissions || []).includes('FIELD_PORTAL')) {
        this.denied = true
        return
      }
      this.user = user
    } catch (e) {
      if (e.response?.status === 401) {
        this.$auth.setAuthenticated(false)
        this.$router.replace({ name: 'login' })
      } else {
        this.denied = true
      }
    }
  },
}
</script>

<style scoped>
.field-layout {
  background: #f5f5f5;
}
.field-layout__content {
  max-width: 720px;
  margin: 0 auto;
  padding: 20px 16px 32px;
}
</style>
